import { AppApiService } from '@services/app.api.service';
import { JWTService } from '@services/jwt.service';

import { decodeJWT, removeLastSlashFromUrl } from '@helpers';

import {
  SET_UM_URL,
  SET_CLIENT_ID,
  SET_API_VERSION,
  GET_APP_SETTINGS,
} from '@store/modules/app.types';

import { AUTH_NAMESPACE } from '@store/modules/auth.types';

export default {
  namespaced: true,

  state: {
    userManagerUrl: JWTService.getUMUrl(),
    clientId: JWTService.getClientId(),
    apiVersion: JWTService.getAPIVersion(),
  },

  mutations: {
    [SET_UM_URL](state, payload) {
      state.userManagerUrl = payload;
      JWTService.setUMUrl(payload);
    },
    [SET_CLIENT_ID](state, payload) {
      state.clientId = payload;
      JWTService.setClientId(payload);
    },
    [SET_API_VERSION](state, payload) {
      state.apiVersion = payload;
      JWTService.setAPIVersion(payload);
    },
  },

  actions: {
    async [GET_APP_SETTINGS]({ commit }) {
      try {
        const { userManagerUrl, version, clientId } = await AppApiService.getAppSettings();

        commit(SET_UM_URL, removeLastSlashFromUrl(userManagerUrl));
        commit(SET_CLIENT_ID, clientId);
        commit(SET_API_VERSION, version);

        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },

  getters: {
    userName: (state, getters, { [AUTH_NAMESPACE]: { token } }) => decodeJWT(token).name,
  },
};
